import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `ComponentFormulaNode` is a marker in a formula to indicate that
 * the contained expression is of interest for the user.
 *
 * @param {string} name - name of component
 * @param {string} type - Indicator for the way to format values. Look
 *   at KeyFigure.valueTypes() for a list of format indicators
 */
export default class ComponentFormulaNode extends WrapperFormulaNode {
	constructor({ name, type } = {}) {
		super(...arguments);

		this._name = name;
		this._type = type;
	}

	getType() {
		return this._type;
	}

	getValueType() {
		return this._type;
	}

	getName() {
		return this._name;
	}

	isLeaf() {
		return true;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitComponentNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.name = this._name;
		properties.valueType = this._type;

		return properties;
	}

	static getType() {
		return "Component";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.type = data.valueType;
	}
}
